<div 
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" 
  (click)="onBackdropClick()"
>
  <div 
    class="bg-white rounded-2xl p-6 max-w-md mx-4 shadow-xl" 
    (click)="$event.stopPropagation()"
  >
    <h3 class="text-2xl font-bold text-gray-900 mb-4">Confirm Logout</h3>
    <p class="text-gray-600 mb-6">Are you sure you want to log out?</p>
    
    <div class="flex gap-3 justify-end">
      <button
        type="button"
        (click)="onCancel()"
        class="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onConfirm()"
        class="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
      >
        Logout
      </button>
    </div>
  </div>
</div>
